/**
@prop --ux-sf-footer-bg-color - Background color of the footer
@prop --ux-sf-footer-color - Primary color of the footer
@prop --ux-sf-footer-backdrop-filter - Backdrop filter for the footer
 */
ux-iws-sf-cta-footer {
    --ux-button-bg-color: transparent;
    --ux-button-text-color: var(--ux-sf-footer-color, #fff);
    --ux-button-border-color: var(--ux-sf-footer-color, #fff);
    --ux-button-hover-bg-color: rgba(0, 0, 0, 0.2);
    --ux-button-hover-border-color: var(--ux-sf-footer-color, #fff);
    --ux-button-hover-text-color: var(--ux-sf-footer-color, #fff);
    --ux-button-focus-bg-color: rgba(0, 0, 0, 0.2);
    --ux-button-focus-border-color: var(--ux-sf-footer-color, #fff);
    --ux-button-focus-text-color: var(--ux-sf-footer-color, #fff);
    --ux-button-primary-bg-color: transparent;
    --ux-button-primary-text-color: var(--ux-sf-footer-color, #fff);
    --ux-button-primary-border-color: var(--ux-sf-footer-color, #fff);
    --ux-button-primary-hover-bg-color: rgba(0, 0, 0, 0.2);
    --ux-button-primary-hover-border-color: var(--ux-sf-footer-color, #fff);
    --ux-button-primary-hover-text-color: var(--ux-sf-footer-color, #fff);
    --ux-button-shadow: none;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;
    gap: 20px;
    box-sizing: border-box;
    padding: 30px 15px;
    background-color: var(--ux-sf-footer-bg-color, #000);
    backdrop-filter: var(--ux-sf-footer-backdrop-filter, none);
    color: var(--ux-sf-footer-color, #fff);
    @include font(light);

    p,
    h3,
    h4,
    h5 {
        color: currentColor;
    }

    div[slot="cta"] {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }
}

.ux-iws-sf-cta-footer {
    &__text {
        display: block;
        color: var(--ux-sf-footer-color, #fff);
        text-align: center;

        *:first-of-type {
            margin-top: 0;
        }

        *:last-of-type {
            margin-bottom: 0;
        }
    }

    &__cta {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }

    &__hidden {
        display: none;
    }
}
